"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRouter = createRouter;

var _typeof2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.regexp.to-string");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _vue = _interopRequireDefault(require("vue"));

var _vueRouter = _interopRequireDefault(require("vue-router"));

var _helper = require("@/services/helper/helper.service");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var helper = new _helper.Helper();
/*const loadView = (view) => {
  return () => import('@/views/' + view + '/' + view);

  return process.env.NODE_ENV === 'localhost'
    ? () => import('@/views/' + view + '/' + view)
    : () => import(`@/views/${view}/${view}`);
};*/

var router = new _vueRouter.default({
  routes: [// Global
  {
    path: '/',
    name: 'login',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/login.vue'));
      });
    },
    meta: {
      unauthenticated: true
    }
  }, {
    path: '/sso',
    name: 'sso',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/login/login.vue'));
      });
    },
    meta: {
      unauthenticated: true
    }
  }, {
    path: '/page-not-found',
    name: 'notFound',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/not-found/not-found.vue'));
      });
    }
  }, {
    path: '/unauthorized',
    name: 'unauthorized',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/unauthorized/unauthorized.vue'));
      });
    }
  }, {
    path: '/settings',
    name: 'settings',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/settings/settings.vue'));
      });
    },
    meta: {
      authenticated: true,
      breadcrumb: [{
        name: 'settings'
      }]
    }
  }, {
    path: '/map',
    name: 'map',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/map/map.vue'));
      });
    },
    meta: {
      isOpenTab: true,
      authenticated: true
    }
  }, // Admin
  {
    path: '/customer',
    name: 'customer',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/customer/customer.vue'));
      });
    },
    meta: {
      authenticated: true,
      admin: true,
      breadcrumb: [{
        name: 'customer'
      }]
    }
  }, {
    path: '/admin-dashboard',
    name: 'adminDashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/dashboard/admin-dashboard/admin-dashboard.vue'));
      });
    },
    meta: {
      authenticated: true,
      admin: true,
      breadcrumb: []
    }
  }, {
    path: '/admin-zones',
    name: 'adminZones',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/admin-zones/admin-zones.vue'));
      });
    },
    meta: {
      authenticated: true,
      admin: true,
      breadcrumb: [{
        name: 'adminZones'
      }]
    }
  }, // Dashboard
  {
    path: '/dashboard',
    name: 'orderDashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/dashboard/order-dashboard/order-dashboard.vue'));
      });
    },
    meta: {
      authenticated: true
    }
  }, {
    path: '/dashboard/carrier',
    name: 'carrierDashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/dashboard/carrier-dashboard/carrier-dashboard.vue'));
      });
    },
    meta: {
      permission: ['lastMileDelivery', 'lastMileV2', 'lastMileDeliveryWellcome', 'lastMileDeliveryPricerite'],
      authenticated: true
    }
  }, // Data
  {
    path: '/data/zone',
    name: 'dataZone',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/zone-v2/zone-v2.vue'));
      });
    },
    meta: {
      permission: ['data'],
      authenticated: true
    }
  }, {
    path: '/data/location',
    name: 'dataLocation',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/location/location.vue'));
      });
    },
    meta: {
      permission: ['data'],
      authenticated: true,
      breadcrumb: [{
        name: 'location'
      }]
    }
  }, // Last Mile Delivery
  {
    path: '/last-mile-delivery/main-dashboard',
    name: 'lmdDashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-delivery/main-dashboard/main-dashboard.vue'));
      });
    },
    meta: {
      permission: ['lastMileDelivery'],
      authenticated: true
    }
  }, {
    path: '/last-mile-delivery/manual-assign',
    name: 'lmdManualAssign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-delivery/manual-assign/manual-assign.vue'));
      });
    },
    meta: {
      permission: ['lastMileDelivery'],
      authenticated: true
    }
  }, {
    path: '/last-mile-delivery/auto-assign',
    name: 'lmdAutoAssign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-delivery/auto-assign/auto-assign.vue'));
      });
    },
    meta: {
      permission: ['lastMileDelivery'],
      authenticated: true
    }
  }, {
    path: '/last-mile-delivery/logs',
    name: 'lmdLogs',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/logs/logs.vue'));
      });
    },
    meta: {
      permission: ['lastMileDelivery'],
      authenticated: true,
      breadcrumb: [{
        name: 'logs'
      }]
    }
  }, // Last Mile Delivery V2
  {
    path: '/last-mile-v2/main-dashboard',
    name: 'lmdV2Dashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-v2/main-dashboard/main-dashboard.vue'));
      });
    },
    meta: {
      permission: ['lastMileV2'],
      authenticated: true
    }
  }, {
    path: '/last-mile-v2/main-logs',
    name: 'lmdV2Logs',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-v2/main-logs/main-logs.vue'));
      });
    },
    meta: {
      permission: ['lastMileV2'],
      authenticated: true
    }
  }, {
    path: '/last-mile-v2/manual-assign',
    name: 'lmdV2ManualAssign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-v2/manual-assign/manual-assign.vue'));
      });
    },
    meta: {
      permission: ['lastMileV2'],
      authenticated: true
    }
  }, {
    path: '/last-mile-v2/auto-assign',
    name: 'lmdV2AutoAssign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-v2/auto-assign/auto-assign.vue'));
      });
    },
    meta: {
      permission: ['lastMileV2'],
      authenticated: true
    }
  }, // Last Mile Delivery Pricerite
  {
    path: '/last-mile-delivery/pricerite/main-dashboard',
    name: 'lmdPriceriteDashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-v2/main-dashboard/main-dashboard.vue'));
      });
    },
    meta: {
      permission: ['lastMileDeliveryPricerite'],
      authenticated: true
    }
  }, {
    path: '/last-mile-delivery/pricerite/manual-assign',
    name: 'lmdPriceriteManualAssign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-delivery-pricerite/manual-assign/manual-assign.vue'));
      });
    },
    meta: {
      permission: ['lastMileDeliveryPricerite'],
      authenticated: true
    }
  }, {
    path: '/last-mile-delivery/pricerite/auto-assign',
    name: 'lmdPriceriteAutoAssign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-delivery-pricerite/auto-assign/auto-assign.vue'));
      });
    },
    meta: {
      permission: ['lastMileDeliveryPricerite'],
      authenticated: true
    }
  }, {
    path: '/last-mile-delivery/pricerite/logs',
    name: 'lmdPriceriteLogs',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/logs/logs.vue'));
      });
    },
    meta: {
      permission: ['lastMileDeliveryPricerite'],
      authenticated: true,
      breadcrumb: [{
        name: 'logs'
      }]
    }
  }, // Last Mile Delivery Wellcome
  {
    path: '/last-mile-delivery/wellcome/main-dashboard',
    name: 'lmdWellcomeDashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-v2/main-dashboard/main-dashboard.vue'));
      });
    },
    meta: {
      permission: ['lastMileDeliveryWellcome'],
      authenticated: true
    }
  }, {
    path: '/last-mile-delivery/wellcome/manual-assign',
    name: 'lmdWellcomeManualAssign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-delivery-wellcome/manual-assign/manual-assign.vue'));
      });
    },
    meta: {
      permission: ['lastMileDeliveryWellcome'],
      authenticated: true
    }
  }, {
    path: '/last-mile-delivery/wellcome/auto-assign',
    name: 'lmdWellcomeAutoAssign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-delivery-wellcome/auto-assign/auto-assign.vue'));
      });
    },
    meta: {
      permission: ['lastMileDeliveryWellcome'],
      authenticated: true
    }
  }, {
    path: '/last-mile-delivery/wellcome/logs',
    name: 'lmdWellcomeLogs',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/logs/logs.vue'));
      });
    },
    meta: {
      permission: ['lastMileDeliveryWellcome'],
      authenticated: true,
      breadcrumb: [{
        name: 'logs'
      }]
    }
  }, // Milkrun
  {
    path: '/milk-run/main-dashboard',
    name: 'mrDashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/milk-run/main-dashboard/main-dashboard.vue'));
      });
    },
    meta: {
      permission: ['milkRun'],
      authenticated: true
    }
  }, {
    path: '/milk-run/lateness-dashboard',
    name: 'mrLatenessDashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/milk-run/lateness-dashboard/lateness-dashboard.vue'));
      });
    },
    meta: {
      permission: ['milkRun'],
      authenticated: true
    }
  }, {
    path: '/milk-run/summary-dashboard',
    name: 'mrSummaryDashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/milk-run/summary-dashboard/summary-dashboard.vue'));
      });
    },
    meta: {
      permission: ['milkRun'],
      authenticated: true
    }
  }, {
    path: '/milk-run/manual-assign',
    name: 'mrManualAssign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/milk-run/manual-assign/manual-assign.vue'));
      });
    },
    meta: {
      permission: ['milkRun'],
      authenticated: true
    }
  }, // Milkrun V2
  {
    path: '/milk-run-v2/main-dashboard',
    name: 'mr2Dashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/milk-run-v2/main-dashboard/main-dashboard.vue'));
      });
    },
    meta: {
      permission: ['milkRunV2'],
      authenticated: true
    }
  }, {
    path: '/milk-run-v2/logs',
    name: 'mr2Logs',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/milk-run-logs/milk-run-logs.vue'));
      });
    },
    meta: {
      permission: ['milkRunV2'],
      authenticated: true,
      breadcrumb: [{
        name: 'logs'
      }]
    }
  }, // Railway
  {
    path: '/railway/main-dashboard',
    name: 'railwayDashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/railway/main-dashboard/main-dashboard.vue'));
      });
    },
    meta: {
      permission: ['railway'],
      authenticated: true
    }
  }, {
    path: '/railway/manual-assign',
    name: 'railwayManualAssign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/railway/manual-assign/manual-assign.vue'));
      });
    },
    meta: {
      permission: ['railway'],
      authenticated: true
    }
  }, // Report
  {
    path: '/report/lmd-load-plan',
    name: 'lmdLoadPlanReport',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-delivery/load-plan-report/load-plan-report.vue'));
      });
    },
    meta: {
      permission: ['lastMileDelivery'],
      authenticated: true,
      breadcrumb: [{
        name: 'lmdLoadPlanReport'
      }]
    }
  }, {
    path: '/report/lmd-truck-summary',
    name: 'lmdTruckSummaryReport',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/last-mile-delivery/truck-summary-report/truck-summary-report.vue'));
      });
    },
    meta: {
      permission: ['lastMileDelivery'],
      authenticated: true,
      breadcrumb: [{
        name: 'lmdTruckSummaryReport'
      }]
    }
  }, {
    path: '/report/milk-run-summary',
    name: 'mrSummaryReport',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/milk-run/summary-report/summary-report.vue'));
      });
    },
    meta: {
      permission: ['milkRun'],
      authenticated: true,
      breadcrumb: [{
        name: 'mrSummaryReport'
      }]
    }
  }, {
    path: '/report/railway-summary',
    name: 'railwaySummaryReport',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/railway/summary-report/summary-report.vue'));
      });
    },
    meta: {
      permission: ['railway'],
      authenticated: true,
      breadcrumb: [{
        name: 'railwaySummaryReport'
      }]
    }
  }, {
    path: '*',
    redirect: '/page-not-found'
  }]
});

function createRouter() {
  var vueInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _vue.default;
  var store = arguments.length > 1 ? arguments[1] : undefined;
  vueInstance.use(_vueRouter.default);
  router.beforeEach( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
      var isLogIn, userInfo, k, isSuccess, hasUserInfo, b, _hasUserInfo, bread, url;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!window.localStorage.getItem('rld')) {
                _context.next = 5;
                break;
              }

              window.localStorage.removeItem('rld');
              window.location.reload();
              _context.next = 98;
              break;

            case 5:
              _context.next = 7;
              return store.commit('common/SET_IS_TAB', to.meta.isOpenTab || false);

            case 7:
              _context.next = 9;
              return store.commit('common/SET_LOADING', true);

            case 9:
              isLogIn = store.getters['authentication/isLogIn'];
              userInfo = store.getters['authentication/userInformation'] || {}; // sso

              k = helper.get(to, 'query.k', null);

              if (!(to.name === 'sso')) {
                _context.next = 62;
                break;
              }

              if (!(helper.isUndefined(k) && !isLogIn)) {
                _context.next = 16;
                break;
              }

              next({
                name: 'login'
              });
              return _context.abrupt("return");

            case 16:
              if (!isLogIn) {
                _context.next = 21;
                break;
              }

              next({
                name: helper.isUndefined(from.name) ? 'orderDashboard' : from.name
              });
              _context.next = 20;
              return store.commit('common/SET_LOADING', false);

            case 20:
              return _context.abrupt("return");

            case 21:
              _context.next = 23;
              return store.dispatch('authentication/logInSSO', {
                loginData: {
                  key: k
                },
                remember: true,
                logflows: true
              });

            case 23:
              isSuccess = _context.sent;

              if (isSuccess) {
                _context.next = 27;
                break;
              }

              next({
                name: 'login'
              });
              return _context.abrupt("return");

            case 27:
              if (!(Object.keys(userInfo).length === 0 && userInfo.constructor === Object)) {
                _context.next = 57;
                break;
              }

              _context.next = 30;
              return store.dispatch('authentication/loadUserInformation', {
                lfToken: store.getters['authentication/lfToken']
              });

            case 30:
              hasUserInfo = _context.sent;

              if (!hasUserInfo) {
                _context.next = 54;
                break;
              }

              if (hasUserInfo === '1') {
                store.dispatch('authentication/logOutUser');
                window.localStorage.setItem('rld', '1');
                next({
                  path: '/'
                });
              }

              if (hasUserInfo === '2') {
                store.dispatch('authentication/logOutUser');
                window.localStorage.setItem('hasNoAccess', '1');
                window.localStorage.setItem('rld', '1');
                next({
                  path: '/'
                });
              }

              userInfo = store.getters['authentication/userInformation']; // HACK - NEEDS TO BE REFACTORED

              if (store.getters['authentication/isAdmin']) {
                _context.next = 52;
                break;
              }

              _context.next = 38;
              return store.dispatch('common/loadCoreInformation');

            case 38:
              _context.next = 40;
              return store.dispatch('lastMileDelivery/loadCoreInformation');

            case 40:
              _context.next = 42;
              return store.dispatch('lastMileDeliveryPricerite/loadCoreInformation');

            case 42:
              _context.next = 44;
              return store.dispatch('lastMileDeliveryWellcome/loadCoreInformation');

            case 44:
              _context.next = 46;
              return store.dispatch('lastMileV2/loadCoreInformation');

            case 46:
              _context.next = 48;
              return store.dispatch('milkRun/loadCoreInformation');

            case 48:
              _context.next = 50;
              return store.dispatch('milkRunV2/loadCoreInformation');

            case 50:
              _context.next = 52;
              return store.dispatch('railway/loadCoreInformation');

            case 52:
              _context.next = 57;
              break;

            case 54:
              store.dispatch('authentication/logOutUser');
              window.localStorage.setItem('rld', '1');
              next({
                path: '/'
              });

            case 57:
              b = to.meta.breadcrumb ? (0, _toConsumableArray2.default)(to.meta.breadcrumb) : null;

              if (b) {
                b.unshift({
                  name: 'dashboard',
                  link: '#'
                });
              }

              store.commit('common/SET_BREADCRUMB_LIST', b);
              next({
                name: 'orderDashboard'
              });
              return _context.abrupt("return");

            case 62:
              if (!(isLogIn && Object.keys(userInfo).length === 0 && userInfo.constructor === Object)) {
                _context.next = 92;
                break;
              }

              _context.next = 65;
              return store.dispatch('authentication/loadUserInformation', {
                lfToken: store.getters['authentication/lfToken']
              });

            case 65:
              _hasUserInfo = _context.sent;

              if (!_hasUserInfo) {
                _context.next = 89;
                break;
              }

              if (_hasUserInfo === '1') {
                store.dispatch('authentication/logOutUser');
                window.localStorage.setItem('rld', '1');
                next({
                  path: '/'
                });
              }

              if (_hasUserInfo === '2') {
                store.dispatch('authentication/logOutUser');
                window.localStorage.setItem('hasNoAccess', '1');
                window.localStorage.setItem('rld', '1');
                next({
                  path: '/'
                });
              }

              userInfo = store.getters['authentication/userInformation']; // HACK - NEEDS TO BE REFACTORED

              if (store.getters['authentication/isAdmin']) {
                _context.next = 87;
                break;
              }

              _context.next = 73;
              return store.dispatch('common/loadCoreInformation');

            case 73:
              _context.next = 75;
              return store.dispatch('lastMileDelivery/loadCoreInformation');

            case 75:
              _context.next = 77;
              return store.dispatch('lastMileDeliveryPricerite/loadCoreInformation');

            case 77:
              _context.next = 79;
              return store.dispatch('lastMileDeliveryWellcome/loadCoreInformation');

            case 79:
              _context.next = 81;
              return store.dispatch('lastMileV2/loadCoreInformation');

            case 81:
              _context.next = 83;
              return store.dispatch('milkRun/loadCoreInformation');

            case 83:
              _context.next = 85;
              return store.dispatch('milkRunV2/loadCoreInformation');

            case 85:
              _context.next = 87;
              return store.dispatch('railway/loadCoreInformation');

            case 87:
              _context.next = 92;
              break;

            case 89:
              store.dispatch('authentication/logOutUser');
              window.localStorage.setItem('rld', '1');
              next({
                path: '/'
              });

            case 92:
              bread = to.meta.breadcrumb ? (0, _toConsumableArray2.default)(to.meta.breadcrumb) : null;

              if (bread) {
                bread.unshift({
                  name: 'dashboard',
                  link: '#'
                });
              }

              store.commit('common/SET_BREADCRUMB_LIST', []);
              _context.next = 97;
              return store.commit('common/SET_LOADING', false);

            case 97:
              if (to.meta.authenticated) {
                if (store.getters['authentication/isLogIn']) {
                  store.commit('common/SET_BREADCRUMB_LIST', bread);

                  if (store.getters['authentication/isAdmin']) {
                    if (to.meta.admin) {
                      next();
                    } else {
                      next({
                        path: '/unauthorized'
                      });
                    }
                  } else {
                    if (!to.meta.admin) {
                      next();
                    } else {
                      next({
                        path: '/unauthorized'
                      });
                    }
                  }
                } else {
                  next({
                    path: '/'
                  });
                }
              } else if (to.meta.unauthenticated) {
                if (!store.getters['authentication/isLogIn']) {
                  store.commit('common/SET_BREADCRUMB_LIST', bread);
                  next();
                } else {
                  if (store.getters['authentication/isAdmin']) {
                    next({
                      path: '/admin-dashboard'
                    });
                  } else {
                    url = {
                      path: '/dashboard'
                    };

                    if (to.query.r) {
                      url['path'] = Buffer.from(to.query.r.toString(), 'base64').toString('ascii');
                    }

                    next(url);
                  }
                }
              } else if (!isLogIn && to.path !== '/') {
                next({
                  path: '/'
                });
              } else {
                store.commit('common/SET_BREADCRUMB_LIST', bread);
                next();
              }

            case 98:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }());
  return router;
}